import React from "react";
import { useLang } from "../i18n";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/fx/Reveal";

export const LegalLayout = ({ label, title, sections }) => {
  const { lang } = useLang();
  const list = sections[lang] || sections.ro;
  return (
    <>
      <PageHero label={label} title={title} />
      <section className="py-20 md:py-28">
        <div className="container-pdr max-w-3xl">
          <div className="space-y-10">
            {list.map((s, i) => (
              <Reveal key={i} delay={i * 0.04}>
                <div className="border-l border-white/10 pl-6">
                  <h2 className="font-display text-xl font-bold text-white md:text-2xl">{s.h}</h2>
                  <p className="mt-3 text-base leading-relaxed text-white/60">{s.p}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <p className="mt-14 font-mono text-xs text-white/35">
            {lang === "ro" ? "Ultima actualizare" : "Last updated"}: 2026
          </p>
        </div>
      </section>
    </>
  );
};
